/*
  Dasom Spin-to-Win - email + marketing consent -> server-minted single-use discount
  code that dies 15 minutes after the spin.

  Flow: popup on first visit (9s delay, once) -> visitor enters email + checks the
  consent box -> POST to DASOM_SPIN_ENDPOINT, which picks the tier server-side and
  mints the Shopify code -> wheel animates to the REAL tier -> code + live countdown.
  A persistent chip keeps the countdown visible on every page until the code dies.
  Consented emails also subscribe to the Klaviyo spin list with the tier as a
  profile property. If the endpoint health probe fails, the wheel never shows.
*/
(function () {
  'use strict';
  var EP = window.DASOM_SPIN_ENDPOINT || '';
  var K_KEY = window.DASOM_KLAVIYO_KEY || '';
  var K_LIST = window.DASOM_SPIN_KLAVIYO_LIST || '';
  if (!EP) return;

  // Visual order of tiers on the wheel, clockwise from the top pointer.
  // Must contain exactly the tiers the endpoint can return (api/dasom-spin.js TIERS).
  // Range is 1-8% as of 2026-09-04 (tightened from 1-15%); high and low alternate so
  // no arc of the wheel looks stacked against the player, even though the real odds
  // (set server-side) heavily favor the low end regardless of wheel position.
  var SEGMENTS = [3, 7, 1, 5, 8, 2, 6, 4];
  var SEG_DEG = 360 / SEGMENTS.length;
  var TOP_TIER = Math.max.apply(null, SEGMENTS);

  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function subscribeKlaviyo(email, pct, code) {
    if (!K_KEY) return;
    try {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Dasom Spin Wheel',
            profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Spin Wheel %': pct, 'Spin Wheel Code': code, 'Spin Wheel Date': new Date().toISOString().slice(0, 10), 'Spin Wheel Source': location.host } } } }
          }
        }
      };
      // A list keeps segmentation clean, but consent records fine without one.
      if (K_LIST) body.data.relationships = { list: { data: { type: 'list', id: K_LIST } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K_KEY), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  // ---------- persistent countdown chip ----------
  var chip = null, chipTimer = null;
  function fmt(msLeft) {
    var s = Math.max(0, Math.floor(msLeft / 1000));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }
  function activeCode() {
    var code = LS.get('dsw_code'), exp = parseInt(LS.get('dsw_exp') || '0', 10);
    if (!code || !exp) return null;
    if (Date.now() > exp) { LS.del('dsw_code'); LS.del('dsw_exp'); LS.del('dsw_pct'); LS.set('dsw_done', '1'); return null; }
    return { code: code, exp: exp, pct: LS.get('dsw_pct') || '' };
  }
  function showChip() {
    var a = activeCode();
    if (!a) { if (chip) chip.classList.remove('show'); return; }
    if (!chip) {
      chip = document.createElement('button');
      chip.className = 'dsw-chip';
      chip.type = 'button';
      chip.onclick = function () { location.href = '/discount/' + encodeURIComponent(a.code) + '?redirect=%2Fcollections%2Fall'; };
      document.body.appendChild(chip);
    }
    chip.classList.add('show');
    function tick() {
      var b = activeCode();
      if (!b) { chip.classList.remove('show'); clearInterval(chipTimer); return; }
      chip.innerHTML = '🎁 ' + esc(b.pct) + '% code ' + esc(b.code) + ' · <span class="t">' + fmt(b.exp - Date.now()) + '</span>';
    }
    clearInterval(chipTimer);
    chipTimer = setInterval(tick, 1000);
    tick();
  }

  // ---------- modal ----------
  var modal = document.getElementById('dswModal');
  if (!modal) return;
  var wheel = document.getElementById('dswWheel');
  var form = document.getElementById('dswForm');
  var result = document.getElementById('dswResult');
  var emailIn = document.getElementById('dswEmail');
  var consent = document.getElementById('dswConsent');
  var go = document.getElementById('dswGo');
  var msg = document.getElementById('dswMsg');
  var resTimer = null;

  // build segment labels
  SEGMENTS.forEach(function (pct, i) {
    var mid = i * SEG_DEG + SEG_DEG / 2;
    var el = document.createElement('div');
    el.className = 'dsw-seg' + (pct === TOP_TIER ? ' jackpot' : '');
    // flip labels on the lower/left half so the text never reads upside down
    var flip = mid > 180;
    el.innerHTML = '<span style="display:inline-block' + (flip ? ';transform:rotate(180deg)' : '') + '">' + pct + '%</span>';
    el.style.transform = 'rotate(' + (mid - 90) + 'deg)';
    wheel.appendChild(el);
  });

  function openModal() { modal.classList.add('open'); }
  function closeModal() { modal.classList.remove('open'); }
  document.getElementById('dswX').onclick = closeModal;
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  consent.onchange = function () { go.disabled = !consent.checked; };

  function showResult(pct, code, exp) {
    form.style.display = 'none';
    result.classList.add('show');
    document.getElementById('dswWon').textContent = 'You won ' + pct + '% off';
    document.getElementById('dswCode').textContent = code;
    var apply = document.getElementById('dswApply');
    apply.onclick = function () { location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcollections%2Fall'; };
    var copy = document.getElementById('dswCopy');
    copy.onclick = function () {
      try { navigator.clipboard.writeText(code); copy.textContent = 'Copied ✓'; setTimeout(function () { copy.textContent = 'Copy code'; }, 2000); } catch (e) {}
    };
    var tEl = document.getElementById('dswTimer');
    clearInterval(resTimer);
    resTimer = setInterval(function () {
      var left = exp - Date.now();
      if (left <= 0) { tEl.textContent = 'This code has expired.'; clearInterval(resTimer); return; }
      tEl.textContent = 'Checkout within ' + fmt(left) + ' to use it';
    }, 1000);
  }

  go.onclick = function () {
    var email = emailIn.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; emailIn.focus(); return; }
    if (!consent.checked) return;
    msg.textContent = '';
    go.disabled = true; go.textContent = 'Spinning…';
    fetch(EP, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    }).then(function (r) { if (!r.ok) throw new Error('spin ' + r.status); return r.json(); }).then(function (d) {
      if (!d || !d.code) throw new Error('no code');
      var exp = new Date(d.expiresAt).getTime();
      LS.set('dsw_code', d.code); LS.set('dsw_exp', String(exp)); LS.set('dsw_pct', String(d.pct));
      subscribeKlaviyo(email, d.pct, d.code);
      // land the wheel on the real tier: rotate so the segment centre sits under the pointer
      var idx = SEGMENTS.indexOf(d.pct);
      if (idx < 0) idx = 0;
      var jitter = (Math.random() - 0.5) * (SEG_DEG * 0.5);
      var target = 5 * 360 + (360 - (idx * SEG_DEG + SEG_DEG / 2)) + jitter;
      wheel.style.transform = 'rotate(' + target + 'deg)';
      setTimeout(function () { showResult(d.pct, d.code, exp); showChip(); }, 4400);
    }).catch(function () {
      go.disabled = false; go.textContent = 'Spin the wheel';
      msg.textContent = 'The wheel is napping. Please try again in a moment.';
    });
  };

  // ---------- arming ----------
  showChip();
  if (LS.get('dsw_done') === '1' || activeCode()) return; // already played
  var reopen = document.getElementById('dswReopen');
  function arm() {
    if (reopen) { reopen.classList.add('show'); reopen.onclick = openModal; }
    if (!LS.get('dsw_seen')) {
      setTimeout(function () { LS.set('dsw_seen', '1'); openModal(); }, 9000);
    }
  }
  // only offer the wheel when the endpoint is actually able to mint codes
  fetch(EP, { method: 'GET' }).then(function (r) { return r.json(); }).then(function (h) {
    if (h && h.ready) arm();
  }).catch(function () {});
})();
